module.exports = "/_next/static/images/01_0360w-1f7c4b83fa621f706fcc0fae0541abdf.png.webp";